import React, { useEffect, useRef, } from 'react';
import qrcode from 'qrcode';

export default function QrCode(props) {
  const { uri, size = 240, } = props;
  const canvasEl = useRef(null);
  useEffect(() => {
    if(canvasEl.current == null) return;

    qrcode.toCanvas(canvasEl.current, uri, { width: size, errorCorrectionLevel: 'M' });
  }, [uri, size]);

  return <canvas ref={canvasEl} />;
}
